import React, { ReactNode } from 'react';
import * as Sentry from '@sentry/browser';

type ErrorBoundaryProps = {
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(e: Error): { hasError: boolean } {
    console.log(e);
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo): void {
    Sentry.captureException(error, {
      extra: {
        info: errorInfo,
      },
    });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <div className="flex h-full w-full items-center justify-center">
          <h2 className="text-2xl font-semibold tracking-tight text-foreground">Oops, something went wrong!</h2>
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
